const timeToMs = (time) => {
    if (typeof (time) === 'string') {
        const minuteSecondSplit = time.split(':');
        const minutes = parseInt(minuteSecondSplit[0]);
        const secondCentiSecondSplit = minuteSecondSplit[minuteSecondSplit.length - 1].split('.');
        const seconds = parseInt(secondCentiSecondSplit[0]);
        const centiSeconds = parseInt(secondCentiSecondSplit[secondCentiSecondSplit.length - 1]);

        return (minutes * 60 * 1000) + (seconds * 1000) + (centiSeconds * 10);
    } else if (typeof (time) === 'number') {
        return time;
    } else {
        return 0;
    }
};

const msToTime = (ms, isDifference) => {
    if (typeof (ms) === 'number') {
        let sign = ms < 0 ? '-' : '';
        let time = Math.abs(ms);
        const minutes = Math.floor(time / (60 * 1000));
        time = time - (minutes * 60 * 1000);
        const seconds = Math.floor(time / 1000);
        time = time - (seconds * 1000);
        const centiSeconds = Math.floor(time / 10);

        const minuteString = (minutes < 10 ? '0' : '') + minutes.toFixed(0);
        const secondString = (seconds < 10 ? '0' : '') + seconds.toFixed(0);
        const centiSecondString = (centiSeconds < 10 ? '0' : '') + centiSeconds.toFixed(0);

        return isDifference ? `${sign}${secondString}.${centiSecondString}` : `${sign}${minuteString}:${secondString}.${centiSecondString}`;
    } else if (typeof (ms) === 'string') {
        return ms;
    } else {
        return isDifference ? '00:00.00' : '00.00';
    }
};

export {msToTime, timeToMs};
